// extracted by mini-css-extract-plugin
export default {"fields":"Pvt2F7","time":"GSSXVU","mobile":"_l20yY"};